import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";

function handleRequest(
  state: State,
  { project }: Boundaries["retrieveDiscussions"]["request"],
): State {
  const hasSearchedGroups = state.find(
    (result) => result.project.uuid === project.uuid,
  );

  return hasSearchedGroups
    ? state.map((result) =>
        result.project.uuid === project.uuid
          ? { ...result, request: setRequestStateToPending() }
          : result,
      )
    : [
        ...state,
        {
          project,
          discussions: [],
          request: setRequestStateToPending(),
          page: 0,
          canLoadMore: true,
        },
      ];
}

export { handleRequest };
